const en = {
    num: 'Num',
    creator: "Order Creator",
    createdAt: "Order Creation Time",
    invStatus: 'Inventory status',
    opt: 'Operation',
    startInv: 'Inventory',
    validaFail: 'Verification failed',
    invalidFormat: 'Product name and quantity format must be correct.',
    operator: 'Operator',
    operaTime: 'Operation time',
    invRequest: 'Inventory application form',
    basicInfo: 'Basic information',
    warehouseItems: 'Warehouse products',
    itemList: 'Product list',
    item: 'Product',
    quantity: 'Quantity',
    enterQuantity: 'Please fill in the quantity in stock',
    cancel: 'Cancel',
    next: 'Next',
    addFailed: 'Add failed',
    diffTip: 'Comparing the warehouse barcode with the inventory barcode, there are the following differences:',
    oneClickInOut: 'One click outbound/inbound',
    oneClickIn: 'One click storage',
    oneClickOut: 'One click outbound',
    doError: 'Generating differences failed，{{err}}',
    operationTips: 'The current organization is conducting an inventory and cannot proceed with the operation.',
    createDiff: 'Generate differences',
    endCounting: 'End inventory check',
    getDiffDataTip: 'Obtaining differential data, please wait...',
    countingDataInventorySuccs: 'Inventory data outbound/inbound successful',
    countingFinish: 'Inventory completed',
    countingNoData: 'Inventory data does not exist',
    countingCancelDiff: 'The current difference data has been generated. Once confirmed to cancel, the difference will end.',
    dataMatchFinish: 'Data matching completed, no difference in data!',
    diffDataTip: 'Barcode that exists on the inventory sheet but does not exist in the warehouse：',
    diffDataTip2: 'Barcodes that exist in the warehouse but do not exist in the inventory sheet：',
    onClickDelete: 'One click delete',
    seletedItems: 'Selected {{num}} items',
    againAddScan: 'Add scan order again',
    againDiff: 'Generate differences again',
    countingDataIsOverTip: 'The discrepancy data for this inventory sheet has been generated. Are you sure to retain the discrepancies and end this inventory?',
    countingInSucc: 'Inventory entry successful',
    countingOutSucc: 'Inventory outbound successfully',
    delCountingScanBarcode: 'Are you sure to delete the barcode from this inventory scanning form?',
    barcode: 'Barcode',
    countingBarcodeInProduct: 'The product to which the barcode belongs in the inventory list',
    storeBarcodeInProduct: 'The product to which the barcode belongs in the warehouse',
    optDetail: 'Details',
    countingDetail: 'Inventory Details',
    countingProductData: 'Inventory product data',
    overCouting: 'End inventory check',
    overCoutingTip: 'Are you sure to end this inventory sheet?',
    fillDataDoTip: 'Please select the product and fill in the barcode data before generating the difference',
    noDataOverCounting: 'There is currently no data available to end the inventory',
    lockState: 'Lock State',
    counting: 'Counting',
    notCounting: 'Not Counting',
    done: 'Completed',
    selectOneLocation: 'Only one location can be selected',
    locationLocked: 'This location is being counted and cannot be selected',
    pleaseSelectLocation: 'Please select location',
    addSuccess: 'Count order created',
    usingExistingOrder: 'Using existing count order',
    noCountOrder: 'Count order does not exist',
    executeSuccess: 'Executed successfully',
    executeFailed: 'Execution failed',
    confirmClose: 'Confirm Close',
    confirmCloseContent: 'After closing, the current counting data will be lost. Are you sure you want to close?',
    lotStr: 'Lot',
    systemCount: 'System Count',
    countingCount: 'Counting Count',
    barcodeDiff: 'Barcode Difference',
    noDifference: 'No Difference',
    inconsistent: 'Inconsistent',
    system: 'System',
    systemOnly: 'System Only',
    countingOnly: 'Counting Only',
    selectLocation: 'Select Location',
    inputCountData: 'Input Count Data',
    inputDesc: 'Please enter description',
    inputProductCode: 'Please enter product code',
    inputLot: 'Please enter lot',
    inputCount: 'Please enter count',
    count: 'Count',
    barcodes: 'Barcodes',
    barcodesPlaceholder: 'Separate multiple barcodes with commas',
    barcodeCount: 'barcodes',
    barcodeExceedsCount: 'Barcode count exceeds limit',
    barcodeExceedsCountDesc: 'Barcode count cannot exceed counting value of {{max}}',
    addItem: 'Add Item',
    countResult: 'Count Result',
    diffComparison: 'Difference Comparison',
    complete: 'Complete',
    executeComplete: 'Count order executed',
    executeSuccessDesc: 'The counting has been completed successfully',
    itemsUpdated: 'Count order updated',
    loadFailed: 'Load failed',
    updateFailed: 'Update failed',
    bothExist: 'Both in count and system',
    noBarcodes: 'No barcodes',
    barcodeDiffDetail: 'Barcode difference details',
    viewDiff: 'View differences',
    continueCounting: 'Continue counting',
    diffCodes: "Variant Barcodes",
    normalCodes: "Matched Barcodes",
    countingCodes: "Stocktaking",
    confirmDelete: "Confirm Delete",
    confirmDeleteContent: "The count order data cannot be recovered after deletion. Are you sure you want to delete?",
    deleteSuccess: "Delete successful",
    deleteFailed: "Delete failed",
    saveFailed: "Save failed",
    confirmTerminate: "Confirm Terminate Count",
    confirmTerminateContent: "Terminating the count will delete the current count order. Are you sure you want to terminate?",
    terminateSuccess: "Count order deleted",
    terminateFailed: "Failed to terminate count",
    noCode: "Inventory code does not exist：{{code}}",
    temp: "Temporary Save",
    tempSave: "Confirm to temporarily save this inventory count sheet?",
    tempSaveConfirm: "After temporary save, you will save the current data.",
    batchImport: "Batch Import Counting",
    downloadTemplate: "Download Template",
    importData: "Import Counting",
    invalidTemplate: "Please select the correct template file",
    confirmImport: "Confirm Import",
    productCode: "Product Code",
    productName: "Product Name",
    productModal: "Specification",
    productUom: "Unit",
    bookNum: "Book Quantity",
    countedNum: "Counted Quantity",
    locationIdx: "Location",
    parseDataSuccess: "Successfully parsed {{count}} records",
    parseDataFilter: "Successfully parsed {{count}} records, please check filtered invalid data (rows: {{rows}})",
    locationParseFailed: "Failed to parse locations: {{locations}}",
    importSuccess: "Import counting successful",
    countingCompleted: "Counting completed",
    confirmCloseImport: "Confirm Close Import",
    confirmCloseImportContent: "The imported data will be lost after closing. Are you sure you want to close?",
    confirmDeleteRow: "Confirm Delete",
    confirmDeleteRowContent: "Are you sure you want to delete this row?",
    productCodeNotExisted: "The following product codes do not exist: \"{{codes}}\"",
    countingHistory: "Counting History",
    countingHistoryAll: "Counting History_All",
    inventoryImportTemplate: "Inventory Import Template",
    inputTemp: "Input from Template",
    noLot: "No lot (outbound/inbound orders generated after counting will not generate lot)",
    initLoc: "Preparing location data",
    subErr: "Please enter lot, inventory code, and quantity",
};

export default en;